module.exports = __WEBPACK_EXTERNAL_MODULE_24__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/geom/Matrix3D","root":["openfl","geom","Matrix3D"],"commonjs":"openfl/geom/Matrix3D","commonjs2":"openfl/geom/Matrix3D"}
// module id = 24
// module chunks = 0